import { useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import { fromIsoLocale } from '@izettle/constants';
import { colors } from '@izettle/otto';
import { useInitialization } from '@izettle/react';
import { captureException } from '@sentry/react';
import { useBaseService } from '../hooks/use-service.js';
import { loadScript } from '../load-script.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { KnownService } from '../providers/services.js';
import { shouldLoadWebComponent } from '../utils/rest.js';

const PpProfileWidgetStyles = createGlobalStyle`
  /* stylelint-disable-next-line */
  pp-profile-widget:not(:defined) {
    display: block;
    background-color: ${colors.background.default};
    min-width: 140px;
    min-height: 140px;
  }
`;
const componentName = "pp-profile-widget";
const PpProfileWidget = _ref => {
  let {
    locale,
    onLoaded,
    version = "latest"
  } = _ref;
  const loginUrl = useBaseService(KnownService.Login);
  const paypalUrl = useBaseService(KnownService.PayPal);
  useInitialization(async () => {
    if (!shouldLoadWebComponent(componentName) || !locale) {
      return;
    }
    await loadScript(`https://cdn.izettle.com/components/${componentName}/${version}/index.${fromIsoLocale(locale)}.min.js`);
    onLoaded?.();
  }, locale);
  useEffect(() => {
    const errorMessageListener = event => {
      if (event.source !== window) {
        return;
      }
      const eventData = event.data;
      if (typeof eventData !== "object" || eventData.type !== "pp-profile-widget-error") {
        return;
      }
      const profileWidgetError = new Error(eventData.message);
      profileWidgetError.name = eventData.name;
      captureException(profileWidgetError, {
        tags: {
          "pp-profile-widget": true
        }
      });
    };
    window.addEventListener("message", errorMessageListener);
    return () => {
      window.removeEventListener("message", errorMessageListener);
    };
  }, []);
  if (!locale) {
    return null;
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(PpProfileWidgetStyles, {}), /*#__PURE__*/jsx("pp-profile-widget", {
      locale: locale,
      "logout-url": `${loginUrl}/logout`,
      "pp-base-uri": process.env.APP_ENV !== "production" && paypalUrl || undefined,
      "widget-data-url": `${loginUrl}/profile-widget-data`,
      "data-testid": "pp-profile-widget",
      "use-new-header": "true"
    })]
  });
};

export { PpProfileWidget };
//# sourceMappingURL=pp-profile-widget.js.map
